import { Redirect, Route, Switch } from 'react-router-dom'

import AdminLobby from './components/AdminLobby'
import React from 'react'
import { adminUrl } from 'app/types'
import { AdminJobfairs } from 'app/modules/admin/AdminJobfairs'
import { AdminOrganizations } from './AdminOrganizations'
import { UrlParamReplace } from 'app/helpers/MiscUtils'
import ManageSponsors from './components/Sponsors/ManageSponsors'
import EmailTemplateEditor from './emails/EmailTemplateEditor'

export const AdminRoutes = {
  Jobfairs: `${adminUrl}/jobfairs`,
  Organizations: `${adminUrl}/companies`,
  Lobby: `${adminUrl}/lobby/:orgId/:jobFairId`,
  BoothDetail: `${adminUrl}/lobby/booth/:boothId`,
  Sponsors: `${adminUrl}/sponsors`,
  emailTemplates: `${adminUrl}/email-templates`,
}

const adminBreadCrumbs = [{
  text: 'Companies',
  url: UrlParamReplace(AdminRoutes.Organizations, '', '')
}
]

const AdminPage: React.FC = () => {
  return (
    <>

      <Switch>
        <Route path={AdminRoutes.Organizations}>
          <AdminOrganizations breadcrumbs={adminBreadCrumbs} title='Companies' />
        </Route>
        <Route path={AdminRoutes.Jobfairs} component={AdminJobfairs}>
        </Route>
        <Route path={AdminRoutes.Lobby}>
          <AdminLobby title="Event Lobby" />
        </Route>
        <Route path={AdminRoutes.Sponsors}>
          <ManageSponsors title='Sponsors' ></ManageSponsors>
        </Route>
        <Route path={AdminRoutes.emailTemplates}>
          <EmailTemplateEditor></EmailTemplateEditor>
        </Route>
        <Redirect from='/admin' to={AdminRoutes.Organizations} />
        <Redirect from='/sponsors' to={AdminRoutes.Sponsors} />
        <Redirect from={adminUrl} to={AdminRoutes.Organizations} />
        <Redirect to={AdminRoutes.Organizations} />
      </Switch>
    </>
  )
}

export default AdminPage
